import { gql, useQuery } from "@apollo/client";

const TRADE_ORDERS_QUERY = gql`
  query GetContactProcesses($category: String) {
    listProcessesRunnableByMe(category: $category) {
      id
      key
      name
    }
  }
`;

type ProcessesCategories = "ONBOARDING";

export interface Process {
  key: string;
  name: string;
}

interface ContactProcessesQuery {
  listProcessesRunnableByMe: Process[];
}

export const useGetContactProcesses = (category?: ProcessesCategories) => {
  // Flowable is not in use — skip the query to avoid errors on FA Back.
  const { data, loading, error } = useQuery<ContactProcessesQuery>(
    TRADE_ORDERS_QUERY,
    {
      skip: true,
      fetchPolicy: "network-only",
      variables: {
        category,
      },
    }
  );

  return {
    loading,
    error,
    data: data && data.listProcessesRunnableByMe,
  };
};
